import { createServerFn } from '@tanstack/react-start';
import api from '../utils/api';

export const getCountries = createServerFn()
    .handler(async () => {
        const response = await api('get', 'country');
        return response.data || [];
    });
